// extracted by mini-css-extract-plugin
export default {"appearance-wrapper":"appearance_appearance-wrapper__wCg2L","checkbox-item":"appearance_checkbox-item__PvviF","checkbox":"appearance_checkbox__4x38N"};